import { EditableTextItem } from './EditableTextItem';
import { IRuleStepModel } from 'domains/designers/RuleDesigner/models/RuleStepModel';
import { VerbItem } from './VerbItem';
import { RuleDesignerContext } from 'domains/designers/RuleDesigner/RuleDesignerContext';
import { useContext } from 'react';
import { getStepIntersectionInfo } from '../TruthTableUtils';
import { IEditableTextItemProps } from './EditableTextItem';
import './VerbAndValue.less';
import { getValueIssues, getVerbIssues } from 'domains/designers/RuleDesigner/ValidationUtils';
import { ValidationIcon } from 'domains/designers/common';

interface IVerbAndValueProps {
  ruleStep: IRuleStepModel;
  onEditClick: (event: React.MouseEvent<HTMLButtonElement | HTMLSpanElement>) => void;
  onVerbClick: (target: HTMLButtonElement) => void;
  onActionsClick?: React.MouseEventHandler<HTMLButtonElement>;
  actionsProps?: IEditableTextItemProps['actionsProps'];
}

export function VerbAndValue({ ruleStep, onVerbClick, onEditClick, onActionsClick, actionsProps }: IVerbAndValueProps) {
  const { isDebug } = useContext(RuleDesignerContext);

  const { HasSpecifiedVerb: isOverridden, IsIgnored: isIgnored } = ruleStep.DisplayData;
  const valueIssues = getValueIssues(ruleStep.GetValidations()).concat(isOverridden ? getVerbIssues(ruleStep.GetValidations()) : []);
  const canEdit = !isIgnored && ruleStep.DisplayData.HasValue;
  
  return (
    <div className="tt-verb-and-value">
      <ValidationIcon validationIssues={valueIssues} />
      {isOverridden && !isIgnored && (
        <VerbItem evaluateWithNot={ruleStep.EvaluateWithNot} verb={ruleStep.TokenVerbInfo} onVerbClick={onVerbClick} />
      )}
      <EditableTextItem
        text={ruleStep.TokenValueInfo}
        isInDebug={isDebug}
        onEditClick={onEditClick}
        intersection={getStepIntersectionInfo(ruleStep)}
        showActionsButton={true}
        showEditButton={canEdit}
        showEditableValue={canEdit}
        onActionsClick={onActionsClick}
        actionsProps={actionsProps}
      />
    </div>
  );
}
